module.exports = __webpack_public_path__ + "static/media/tiktok-logo.c457a882.png";